import { localDate } from '../hooks/useClubFeed';

export function scoreValue(value) {
  if (!/^\d{1,2}$/.test(String(value)))
    throw new Error('점수는 0~99 사이의 정수로 입력해 주세요.');
  return Number(value);
}
export function validateMatchInput(match, players) {
  if (
    !['singles', 'doubles'].includes(match.match_type) ||
    !['official', 'friendly'].includes(match.match_category) ||
    (match.match_category === 'official' && match.match_type !== 'doubles')
  ) {
    throw new Error(
      '공식 경기는 복식, 친선 경기는 단식 또는 복식으로 등록해 주세요.',
    );
  }
  if (!['game', 'tiebreak'].includes(match.score_type))
    throw new Error('점수 방식을 선택해 주세요.');
  const day = match.date;
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(day || '') ||
    !Number.isFinite(Date.parse(day)) ||
    new Date(day).toISOString().slice(0, 10) !== day
  )
    throw new Error('경기 날짜를 선택해 주세요.');
  if (day > localDate())
    throw new Error('미래 날짜의 경기는 등록할 수 없습니다.');
  const ids =
    match.match_type === 'doubles'
      ? [match.player1Id, match.player2Id, match.player3Id, match.player4Id]
      : [match.player1Id, match.player2Id];
  if (ids.some((id) => !id) || new Set(ids).size !== ids.length)
    throw new Error('서로 다른 참가 선수를 모두 선택해 주세요.');
  if (players && ids.some((id) => !players.some((player) => player.id === id)))
    throw new Error('현재 명단에 없는 선수가 있습니다. 다시 선택해 주세요.');
  if (!Array.isArray(match.sets) || !match.sets.length || match.sets.length > 5)
    throw new Error('세트는 1~5개로 입력해 주세요.');
  let wins = 0;
  for (const set of match.sets) {
    const a = scoreValue(set.player1Score),
      b = scoreValue(set.player2Score);
    if (a === b) throw new Error('세트 점수는 동점으로 등록할 수 없습니다.');
    wins += a > b ? 1 : -1;
  }
  if (!wins) throw new Error('최종 세트 승자를 확인해 주세요.');
  return wins > 0 ? ids[0] : ids[match.match_type === 'doubles' ? 2 : 1];
}

export function parseMatchRows(text, players, category, scoreType, date) {
  const byName = new Map();
  players.forEach((player) =>
    byName.set(player.name, [...(byName.get(player.name) || []), player]),
  );
  return text
    .split('\n')
    .map((line, index) => ({ line: index + 1, raw: line.trim() }))
    .filter((row) => row.raw)
    .map((row) => {
      try {
        if (row.line > 100)
          throw new Error('한 번에 100줄까지 등록할 수 있습니다.');
        // Keep empty fields: removing them can silently shift names and scores.
        const cells = row.raw.split(',').map((value) => value.trim());
        if (![4, 6].includes(cells.length))
          throw new Error('단식은 4칸, 복식은 6칸으로 입력해 주세요.');
        const doubles = cells.length === 6;
        if (!doubles && category !== 'friendly')
          throw new Error('단식은 친선 경기에서 등록할 수 있습니다.');
        const names = cells.slice(0, -2);
        const members = names.map((name) => {
          const found = byName.get(name) || [];
          if (found.length !== 1)
            throw new Error(
              found.length
                ? '동명이인은 개별 등록을 이용해 주세요.'
                : `선수 확인: ${name || '빈칸'}`,
            );
          return found[0];
        });
        const a = scoreValue(cells.at(-2)),
          b = scoreValue(cells.at(-1));
        const match = {
          date,
          match_type: doubles ? 'doubles' : 'singles',
          match_category: category,
          score_type: scoreType,
          player1Id: members[0].id,
          player2Id: members[1].id,
          player3Id: members[2]?.id || null,
          player4Id: members[3]?.id || null,
          sets: [{ player1Score: a, player2Score: b }],
        };
        const winner_id = validateMatchInput(match);
        return {
          ...row,
          match: { ...match, winner_id },
          summary: `${doubles ? names.slice(0, 2).join(' · ') : names[0]} ${a} : ${b} ${doubles ? names.slice(2).join(' · ') : names[1]}`,
        };
      } catch (error) {
        return { ...row, error: error.message };
      }
    });
}
